/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import 'moment/locale/vi_VN';
// import locale from 'antd/';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import { getLinkArticle } from '@/utils/utils';
import EncodeUrl from '@/utils/encode';
// import { Pagination } from 'antd';
import Pagination from '@/componentWebs/Pagination';

import moment from 'moment';

const pageSize = 20;

moment.locale('vi');

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class Index extends Component {
  state = {
    dataIntroduse: [],
    pagi: {},
  };

  componentDidMount() {
    const { dispatch, data } = this.props;

    dispatch({
      type: 'webs/fetchAllArticle',
      payload: {
        filter: {
          status: '1',
          categoriesId: data.id,
          languagesId: '1',
        },
        range: [0, pageSize - 1],
        // attributes: `id,title,shortDescription,image,createDate,source,tag,author,urlSlugs`,
      },
      callback: res => {
        if (res.success) {
          if (res.result.list.length) {
            this.setState({
              dataIntroduse: (res && res.result && res.result.list) || [],
              pagi: (res && res.result && res.result.pagination) || {},
            });
          }
        }
      },
    });
  }

  handleChangePagi = currentPagesss => {
    const { dispatch, data } = this.props;

    const indexOfLastNews = currentPagesss * pageSize; // vị trí của tin cuối cùng trong list được hiển thị
    const indexOfFirstNews = indexOfLastNews - pageSize;

    dispatch({
      type: 'webs/fetchAllArticle',
      payload: {
        filter: {
          status: '1',
          categoriesId: data.id,
          languagesId: '1',
        },
        range: [indexOfFirstNews, indexOfLastNews - 1],
        // attributes: `id,title,shortDescription,image,createDate,source,tag,author,urlSlugs`,
      },
      callback: res => {
        if (res.success) {
          if (res.result.list.length) {
            this.setState({
              dataIntroduse: (res && res.result && res.result.list) || [],
              pagi: (res && res.result && res.result.pagination) || {},
            });
          }
        }
      },
    });
  };

  render() {
    const { data } = this.props;
    const { dataIntroduse, pagi } = this.state;
    const template =
      data.templateLayouts && data.templateLayouts.templates && data.templateLayouts.templates[0];
    const imageResize =
      template && template.templateLayoutTemplates && template.templateLayoutTemplates.imagesResize;
    const imageResize2 = [
      {
        "desktop": {
          "width": 400,
          "height": 0
        }
      },
      {
        "tablet": {
          "width": 330,
          "height": 0
        }
      },
      {
        "mobile": {
          "width": 385,
          "height": 0
        }
      }
    ]
    return (
      <section className="tuyenBay">
        <div className="container">
          <h1 className="tuyenBay__title flex-center">
            <img src="/static/vietnamTickets/images/subtraction_2.svg" alt="Subtraction" className='lazyload' />
            <span>Tuyến bay yêu thích</span>
            <img src="/static/vietnamTickets/images/subtraction_2.svg" alt="Subtraction" className='lazyload' />
          </h1>
          <div className="tuyenBay__main">
            <div className="tuyenBay__wrapper">
              <div className="row">
                {dataIntroduse &&
                  dataIntroduse.length > 0 &&
                  dataIntroduse.slice(0, 2).map(item => (
                    <div className="col-lg-6 col-md-6" key={item.id}>
                      <div className="tuyenBay__large-box">
                        <a
                          href={`/${EncodeUrl(item.categories.name)}/${item.urlSlugs}/${item.id}`}
                          title={item.title}
                          className="tuyenBay__large-box__img"
                        >
                          <img
                            src={getResponsiveImage(
                              item.image && item.image[0] && item.image[0].file, imageResize
                            )}
                            className='lazyload'
                            alt={item.title}
                          />
                        </a>
                        <div className="wrapper-large-box">
                          <div className="article-box-date flex-a-c">
                            <img src="/static/vietnamTickets/images/clock.svg" alt="clock" className='lazyload' />
                            <span>{moment(item.createDate).format('DD/MM/YYYY')}</span>
                          </div>
                          <a
                            href={`/${EncodeUrl(item.categories.name)}/${item.urlSlugs}/${item.id}`}
                            className="title"
                            title={item.title}
                          >
                            {item.title}
                          </a>
                          <div className="shortDes hidden-m-t">{item.shortDescription}</div>
                          <a
                            href={`/${EncodeUrl(item.categories.name)}/${item.urlSlugs}/${item.id}`}
                            title={item.title}
                            className="link hidden-m-t"
                          >
                            Đọc tiếp
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                {dataIntroduse &&
                  dataIntroduse.length > 2 &&
                  dataIntroduse.slice(2).map(item => (
                    <div className="col-lg-4 col-md-6">
                      <div className="article-box">
                        <a
                          href={`/${EncodeUrl(item.categories.name)}/${item.urlSlugs}/${item.id}`}
                          title={item.title}
                          className="article-box__img"
                        >
                          <img
                            src={getResponsiveImage(
                              item.image && item.image[0] && item.image[0].file, imageResize2
                            )}
                            className='lazyload'
                            alt={item.title}
                          />
                        </a>
                        <div className="article-box-date flex-a-c">
                          <img src="/static/vietnamTickets/images/clock.svg" alt="clock" className='lazyload' />
                          <span>{moment(item.createDate).format('DD/MM/YYYY')}</span>
                        </div>
                        <a
                          href={`/${EncodeUrl(item.categories.name)}/${item.urlSlugs}/${item.id}`}
                          title={item.title}
                          className="title"
                        >
                          {item.title}
                        </a>
                      </div>
                    </div>
                  ))}
              </div>
              {/*  
              <Pagination

                style={{ textAlign: 'right', margin: '20px 0' }}
                onChange={this.handleChangePagi}
                current={pagi && pagi.current}
                total={pagi && pagi.total}
                pageSize={pageSize}
              /> */}

              {pagi.total > pageSize - 1 && (
                <Pagination
                  style={{ textAlign: 'right', marginTop: '20px 0' }}
                  onChange={this.handleChangePagi}
                  current={pagi && pagi.current}
                  total={pagi && pagi.total}
                  pageSize={pageSize}
                />
              )}
            </div>
            <div className="pagiTuyenBay-top hidden-pc" />
          </div>
        </div>
      </section>
    );
  }
}

export default Index;
